module.exports = __webpack_public_path__ + "static/media/archive-file.650814d4.svg";